import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import SubUserTableContainer from "./SubUserTableContainer.js";
import InviteSubUserButton from "./InviteSubUserButton.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useEffect } from "react";
import { useProfile } from "contexts/profileContext/profileContext.js";
import { useToasts } from "react-toast-notifications";

import "./SubUserTable.scss";

const SubUserTable = (props) => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();

  const {
    getSubUsers,
    getSubUserData,
    setSubUsers,
    setOrderAscending,
    setFieldToOrder,
    getLoading,
    setLoading,
    setNumberOfUsers,
    setCurrentPage,
    getSearchTerm,
    getStatusFilter,
    getPermissionFilter,
    setSubUsersCounts,
    setSizeNumber,
    changeSubUserStatusFromExpiredToPending,
  } = useProfile();

  const currentPage = getSubUserData().currentPage;
  const orderAscending = getSubUserData().orderAscending;
  const fieldToOrder = getSubUserData().fieldToOrder;
  const sizeNumber = getSubUserData().sizeNumber;
  const numberOfUsers = getSubUserData().numberOfUsers;
  const subUsers = getSubUsers();
  const { addToast } = useToasts();

  useEffect(() => {
    if (props?.pageSize) {
      setSizeNumber(props.pageSize);
    }
  }, [props.pageSize, setSizeNumber]);

  const getSubUserByStatus = async () => {
    setLoading(true);
    if (window.location.search.includes("removed")) {
      const parameters = {
        field: fieldToOrder,
        orderAsc: orderAscending,
        page: currentPage,
        size: props?.pageSize || sizeNumber,
        searchTerm: getSearchTerm(),
      };

      const response = await apiRequest(
        "SubUsers",
        "GetRemovedSubUsersLogs",
        parameters
      );

      if (response.status === "success") {
        if (response.data) {
          setSubUsers(response.data.RemovedUsers);
          setNumberOfUsers(response.data.Count);
          setLoading(false);
        } else {
          setSubUsers([]);
          setNumberOfUsers(0);
          setLoading(false);
        }
      }
    } else {
      const parameters = {
        field: fieldToOrder,
        orderAsc: orderAscending,
        page: currentPage,
        size: props?.pageSize || sizeNumber,
        isAdminSubUser: getUserData().IsAdminSubUser,
        permissions: getPermissionFilter() || "",
        statuses: getStatusFilter() || "",
        searchTerm: getSearchTerm(),
      };

      const response = await apiRequest(
        "SubUsers",
        "ReactGetSubUsersByStatus",
        parameters
      );

      if (response.status === "success") {
        if (response.data) {
          setSubUsers(response.data.userList);
          setNumberOfUsers(response.data.userAmount);
          setLoading(false);

          // count amount of users of each status
          const statusesCounter = response.data.statusesCounter;
          setSubUsersCounts(statusesCounter);

          response.data.userList.map((item) => {
            if (item.Status === "Expired") {
              item.Status = (
                <div className="status-wrapper">
                  Expired
                  <Button onClick={() => ResendInivtation(item)} xs blank>
                    {getTextByKey("resend-button")}
                  </Button>
                </div>
              );
            }
          });

          // edit sub users to html with action
        } else {
          setSubUsers([]);
          setNumberOfUsers(0);
          setLoading(false);
        }
      }
    }
  };

  const setFieldFilter = (key) => {
    if (key === fieldToOrder) {
      setOrderAscending(!orderAscending);
    } else {
      setFieldToOrder(key);
      setOrderAscending(true);
    }
  };

  useEffect(() => {
    getSubUserByStatus();
  }, [
    currentPage,
    fieldToOrder,
    orderAscending,
    getSearchTerm(),
    getPermissionFilter(),
    getStatusFilter(),
  ]);

  const ResendInivtation = async (item) => {
    const parameters = {
      subUserEmail: item.Email,
      page: currentPage,
      size: props?.pageSize || sizeNumber,
      field: fieldToOrder,
      orderAsc: orderAscending,
      isAdminSubUser: getUserData().IsAdminSubUser,
    };

    const response = await apiRequest(
      "SubUsers",
      "ReactResendAddSubUser",
      parameters,
      "POST"
    );

    if (response.status === "success") {
      changeSubUserStatusFromExpiredToPending(item.Email);
    }

    addToast(getTextByKey("success-resend-sub-user"), {
      appearance: "success",
    });
  };

  return (
    <>
      {getLoading() ? (
        <div className="sub-user-loading-table">
          <LoadingImageElement />
        </div>
      ) : (
        <>
          {!props?.withoutAddSubUserButton && <InviteSubUserButton />}
          {(!subUsers || subUsers.length === 0) && !getLoading() ? (
            <div className="empty-sub-user-table">
              <Image name="inbox-empty" ext="png" alt="no sub users" />
              <h3>{getTextByKey("no-sub-users-title")}</h3>
              <p>
                {getTextByKey(
                  getSearchTerm().length > 0
                    ? "no-sub-users-by-search-param"
                    : "no-sub-users-added-description"
                )}
              </p>
            </div>
          ) : (
            <SubUserTableContainer
              subUsers={subUsers}
              numberOfUsers={numberOfUsers}
              setNumberOfUsers={setNumberOfUsers}
              currentPage={currentPage}
              sizeNumber={props?.pageSize | sizeNumber}
              orderAscending={orderAscending}
              fieldToOrder={fieldToOrder}
              setLoading={setLoading}
              setSubUsers={setSubUsers}
              loading={getLoading()}
              setFieldFilter={setFieldFilter}
              setCurrentPage={setCurrentPage}
              withoutPagination={props?.withoutPagination}
            />
          )}
        </>
      )}
    </>
  );
};

export default SubUserTable;
